export default __webpack_public_path__ + "static/media/liberwood-banner.f65ebd06.png";